export const getTotalIIBB = (state) =>
  state.retenciones.retencionesIIBB.reduce(
    (acc, r) => acc + Number(r.importe || 0),
    0,
  );

export const getTotalTarjetas = (state) =>
  state.tarjetas.reduce((acc, t) => acc + Number(t.importe || 0), 0);

export const getTotalInstrumentos = (state) =>
  state.instrumentos.reduce((acc, i) => acc + Number(i.importe || 0), 0);

export const getTotalEfectivo = (state) => Number(state.recibo.efectivo || 0);
export const getTotalRedondeo = (state) => Number(state.recibo.redondeo || 0);

export const getTotalRetenciones = (state) => {
  const totalIIBB = getTotalIIBB(state);
  return (
    Number(state.retenciones.retSuss || 0) +
    Number(state.retenciones.retDrei || 0) +
    Number(state.retenciones.retGanancias || 0) +
    Number(state.retenciones.retIva || 0) +
    Number(totalIIBB || 0)
  );
};
export const getTotalCobrado = (state) =>
  getTotalEfectivo(state) +
  getTotalTarjetas(state) +
  getTotalInstrumentos(state);

export const getTotalRecibo = (state) =>
  getTotalCobrado(state) + getTotalRetenciones(state);

export const getTotalNeto = (state) =>
  getTotalCobrado(state) - getTotalRetenciones(state);
